export default "__VITE_PUBLIC_ASSET__d205bd7b__"